import React from 'react';
import { Helmet } from 'react-helmet-async';

const BASE_URL = 'https://injectailabs.space';
const DEFAULT_IMAGE = `${BASE_URL}/social.png`;
const SITE_NAME = 'InjectAI Labs';

const SEO = ({ title, description, path = '/', image = DEFAULT_IMAGE }) => {
  const fullTitle = title ? `${title} — ${SITE_NAME}` : `${SITE_NAME} — AI Research Company`;
  const url = `${BASE_URL}${path}`;

  return (
    <Helmet>
      <title>{fullTitle}</title>
      <meta name="description" content={description} />
      <link rel="canonical" href={url} />

      {/* Open Graph */}
      <meta property="og:type" content="website" />
      <meta property="og:url" content={url} />
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={description} />
      <meta property="og:image" content={image} />
      <meta property="og:site_name" content={SITE_NAME} />

      {/* Twitter / X */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:url" content={url} />
      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={image} />
    </Helmet>
  );
};

export default SEO;
